import { lineString } from '@turf/helpers'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { MAP } from 'consts'
import { config } from 'config'
import { I18NService } from 'services'

interface ImgProps {
  width?: string
  height?: string
}

const Image = styled.img<ImgProps>`
  background-position: center;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.foundation.borderRadius};
  width: ${({ width = '150px' }) => width};
  height: ${({ height = '85px' }) => height};
`
interface Props extends ImgProps {
  lotCoordinates?: number[][]
  fieldId?: number
  lotId?: number
}

export const MapImage: React.FC<Props> = ({ lotCoordinates, width, height, fieldId, lotId }) => {
  const history = useHistory()
  const { t } = useTranslation(I18NService.NAMESPACES.LOT_DASHBOARD)

  const getImageUrl = (coordinates: string) => {
    return `${MAP.STATIC_IMAGES.URL}geojson({"type":"FeatureCollection","features":[{"type":"Feature","properties":{"stroke":"%23ffffff","stroke-width":7, "stroke-opacity": 1, "fill":"%239c9a37","fill-opacity":1},"geometry":{"type": "Polygon","coordinates":[${coordinates}]}}]})/auto/${MAP.STATIC_IMAGES.SIZE}?padding=30,30,40&logo=false&access_token=${config.mapboxToken}`
  }

  if (!lotCoordinates) return null

  return (
    <Image
      width={width}
      height={height}
      onClick={() =>
        history.push({
          pathname: '/map',
          search: fieldId && lotId ? `?fieldId=${fieldId}&lotId=${lotId}` : undefined,
        })
      }
      src={getImageUrl(JSON.stringify(lineString(lotCoordinates).geometry.coordinates))}
      alt={t('lotMinimapAlt')}
    />
  )
}
